import { render, staticRenderFns } from "./CbsDownloadButton.vue?vue&type=template&id=e620651c&"
import script from "./CbsDownloadButton.vue?vue&type=script&lang=js&"
export * from "./CbsDownloadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports